import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark,
    faEdit,
    faCheck,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import FileLink from './FileLink';
import styles from './FileSelector.module.css';
import { FileType } from './types';
import { updateFileTitle } from '../../services/api/fileService';

interface FileCardProps {
    file: FileType;
    isEditable?: boolean;
    onChange: (id: string, file: FileType) => void;
    onRemoveFile: (fileId: string) => void;
    onShowFile: (file: FileType) => void;
}

const FileCard: React.FC<FileCardProps> = ({
    file,
    isEditable = false,
    onChange,
    onRemoveFile,
    onShowFile,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editingTitle, setEditingTitle] = useState('');

    const displayTitle = file.title || file.filename;

    const startEditing = () => {
        setIsEditing(true);
        setEditingTitle(displayTitle);
    };

    const cancelEditing = () => {
        setIsEditing(false);
        setEditingTitle('');
    };

    const saveTitle = async () => {
        if (editingTitle.trim() && editingTitle.trim() !== displayTitle) {
            try {
                await updateFileTitle(file._id, editingTitle.trim());
                const updatedFile = { ...file, title: editingTitle.trim() };
                onChange(file._id, updatedFile);
            } catch (error) {
                console.error('Error updating file title:', error);
                // TODO: Add error handling/notification
            }
        }
        cancelEditing();
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            saveTitle();
        } else if (e.key === 'Escape') {
            cancelEditing();
        }
    };
    return (
        <div key={file._id} className={styles.fileCard}>
            <div className={styles.fileInfo}>
                <div className={styles.titleSection}>
                    {isEditing ? (
                        <input
                            type="text"
                            value={editingTitle}
                            onChange={(e) => setEditingTitle(e.target.value)}
                            onKeyPress={handleKeyPress}
                            onBlur={saveTitle}
                            autoFocus
                            className={styles.titleInput}
                        />
                    ) : file.title ? (
                        <h6 className={styles.fileTitle}>{displayTitle}</h6>
                    ) : null}
                    {isEditable && (
                        <>
                            {isEditing ? (
                                <>
                                    <FontAwesomeIcon
                                        icon={faCheck}
                                        className={styles.actionIcon}
                                        onClick={saveTitle}
                                        title="Save"
                                    />
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className={styles.actionIcon}
                                        onClick={cancelEditing}
                                        title="Cancel"
                                    />
                                </>
                            ) : (
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    className={styles.actionIcon}
                                    onClick={startEditing}
                                    title="Edit title"
                                />
                            )}
                        </>
                    )}
                </div>
                {/* <p className={styles.fileName}>{file.filename}</p> */}
                <FileLink file={file} onClick={onShowFile} />
            </div>
            <FontAwesomeIcon
                icon={faXmark}
                className={styles.removeIcon}
                onClick={() => onRemoveFile(file._id)}
                title="Remove file"
            />
        </div>
    );
};

export default FileCard;
